import { StyledProps } from '@/ui/components/types'
import { map } from 'lodash'

const cssPropertyMap: Partial<Record<keyof StyledProps, string>> = {
  p: 'padding',
  pb: 'padding-bottom',
  pt: 'padding-top',
  pl: 'padding-left',
  pr: 'padding-right',
  m: 'margin',
  mb: 'margin-bottom',
  mt: 'margin-top',
  ml: 'margin-left',
  mr: 'margin-right',
  w: 'width',
  h: 'height',
  minW: 'min-width',
  minH: 'min-height',
  maxW: 'max-width',
  maxH: 'max-height',
  bg: 'background',
  gCol: 'grid-column',
  gRow: 'grid-row',
  gtCol: 'grid-template-columns',
  gtRow: 'grid-template-rows'
}

function camelToKebabCase(str: string): string {
  return str.replace(/([a-z0-9]|(?=[A-Z]))([A-Z])/g, '$1-$2').toLowerCase()
}
function cssObjectToString(cssObject: Partial<StyledProps>): {
  desktopStyles: string
  tabletStyles: string
  mobileStyles: string
} {
  let desktopStyles = ''
  let tabletStyles = ''
  let mobileStyles = ''

  map(cssObject, (value, key) => {
    const cssProperty = cssPropertyMap[key as keyof StyledProps] || key
    const kebabCaseProperty = camelToKebabCase(cssProperty)

    const desktopValue = String(value)
      .replace(/@t:[^@]*|@m:[^@]*/g, '')
      .trim()

    desktopStyles += `${kebabCaseProperty}:${desktopValue};`

    if (value && typeof value === 'string') {
      const tabletValue = (value.match(/@t:[^@]*/) || [])
        .toString()
        .replace('@t:', '')
        .trim()

      const mobileValue = (value.match(/@m:[^@]*/) || [])
        .toString()
        .replace('@m:', '')
        .trim()

      if (tabletValue) {
        tabletStyles += `${kebabCaseProperty}:${tabletValue};`
      }
      if (mobileValue) {
        mobileStyles += `${kebabCaseProperty}:${mobileValue};`
      }
    }
  })

  return {
    desktopStyles,
    tabletStyles,
    mobileStyles
  }
}

export default function generateStyledJsx(styled?: StyledProps) {
  let desktopStyles = ''
  let tabletStyles = ''
  let mobileStyles = ''
  if (styled) {
    const styles = cssObjectToString(styled)
    desktopStyles = styles.desktopStyles
    tabletStyles = styles.tabletStyles
    mobileStyles = styles.mobileStyles
  }

  return { desktopStyles, tabletStyles, mobileStyles }
}
